export default "__VITE_ASSET__RLD9fb01__"